import React, { useEffect, useState } from "react";
import CertificationBodyReviewStep1 from "../../certificationBody/review/flow/certificationBodyReviewStep1";
import { setStakeholderApplicationNumber } from "../../../app/api/NOCU/helpers/applicationApiHelpers";
import { SectionRow } from "../../../layouts/sections";
import { Button, Stack } from "@mui/material";
import { getStepStatusByApplicationId } from "../../../app/api/NOCU/applicationAPI";
import TopButtonArray from "./components/TopButtonArray";
import CertificationBodyReviewStep2 from "../../certificationBody/review/flow/certificationBodyReviewStep2";
import CertificationBodyReviewStep3 from "../../certificationBody/review/flow/certificationBodyReviewStep3";
import CertificationBodyReviewStep4 from "../../certificationBody/review/flow/certificationBodyReviewStep4";
import CertificationBodyReviewStep5 from "../../certificationBody/review/flow/certificationBodyReviewStep5";
import LabReviewStep1 from "./../../labs/review/flow/LabStep1";
import LabReviewStep2 from "./../../labs/review/flow/LabStep2";
import LabReviewStep3 from "./../../labs/review/flow/LabStep3";
import LabReviewStep4 from "./../../labs/review/flow/LabStep4";
import LabReviewStep5 from "./../../labs/review/flow/LabStep5";
import LoaderComponent from "../../../components/Loader/LoaderComponent";

const CertificationBodySummaryView = ({ applicationId }) => {
	const [selectedPage, setSelectedPage] = useState(0);
	const [statusArray, setStatusArray] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setStakeholderApplicationNumber(applicationId);
		getStepStatusByApplicationId(applicationId)
			.then((res) => {
				setStatusArray(res.data);
			})
			.finally(() => {
				setTimeout(() => setLoading(false), 1000);
			});
	}, [applicationId]);

	const btnNames = [
		"Business Details",
		"Contact Personnel",
		"Management Personnel",
		"Certificates",
		"Other Documents",
	];

	return (
		<div>
			<SectionRow className='w-full justify-center'>
				{statusArray && (
					<TopButtonArray
						nameArray={btnNames}
						selectedPage={selectedPage}
						setSelectedPage={setSelectedPage}
						statusArray={statusArray}
					/>
				)}
			</SectionRow>
			{!loading && selectedPage === 0 ? (
				<LabReviewStep1
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 1 ? (
				<LabReviewStep2
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 2 ? (
				<LabReviewStep3
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 3 ? (
				<LabReviewStep4
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 4 ? (
				<LabReviewStep5
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : (
				<></>
			)}
			<LoaderComponent isOpen={loading} />
		</div>
	);
};

export default CertificationBodySummaryView;
